/**
 * La dashboard salvata della persona collegata: si legge all'apertura della
 * pagina e si riscrive con "Salva". Non si salva mai niente da solo.
 */

import { useCallback, useEffect, useState } from 'react';
import { leggiDisposizione, scriviDisposizione } from '../lib/dashboard/salvataggio';
import type { Json } from '../types/database.types';

export type StatoDisposizione =
  | { stato: 'caricamento' }
  | { stato: 'pronto'; salvato: unknown | null }
  | { stato: 'errore' };

export function useDisposizioneSalvata(utenteId: string | undefined) {
  const [stato, setStato] = useState<StatoDisposizione>({ stato: 'caricamento' });

  useEffect(() => {
    if (!utenteId) return;
    let attivo = true;
    setStato({ stato: 'caricamento' });
    leggiDisposizione(utenteId).then(
      (salvato) => { if (attivo) setStato({ stato: 'pronto', salvato }); },
      () => { if (attivo) setStato({ stato: 'errore' }); },
    );
    return () => { attivo = false; };
  }, [utenteId]);

  /** Scrive (o, con null, torna alla base). Solleva l'errore: lo mostra la pagina. */
  const salva = useCallback(async (layout: Json | null) => {
    if (!utenteId) throw new Error('Utente non riconosciuto');
    await scriviDisposizione(utenteId, layout);
    setStato({ stato: 'pronto', salvato: layout });
  }, [utenteId]);

  return { stato, salva };
}
